import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

// Lista modelli con filtri opzionali
export async function listModelli(token, { tab = "miei", q, tipo, page = 1, perPage = 20 } = {}) {
  const params = { tab, page, per_page: perPage };
  if (q) params.q = q;
  if (tipo) params.tipo = tipo;
  const res = await axios.get(`${API_URL}/api/fatturazione/modelli`, {
    headers: authHeaders(token),
    params,
  });
  return res.data;
}

// Dettaglio singolo modello
export async function getModello(token, modelloId) {
  const res = await axios.get(`${API_URL}/api/fatturazione/modelli/${modelloId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

// Crea nuovo modello
export async function creaModello(token, data) {
  const res = await axios.post(`${API_URL}/api/fatturazione/modelli`, data, {
    headers: authHeaders(token),
  });
  return res.data;
}

// Aggiorna modello
export async function aggiornaModello(token, modelloId, data) {
  const res = await axios.put(`${API_URL}/api/fatturazione/modelli/${modelloId}`, data, {
    headers: authHeaders(token),
  });
  return res.data;
}

// Elimina modello
export async function eliminaModello(token, modelloId) {
  const res = await axios.delete(`${API_URL}/api/fatturazione/modelli/${modelloId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

// Duplica modello
export async function duplicaModello(token, modelloId) {
  const res = await axios.post(`${API_URL}/api/fatturazione/modelli/${modelloId}/duplica`, {}, {
    headers: authHeaders(token),
  });
  return res.data;
}

// Preview righe risolte di un modello per fascicolo + mese
export async function previewModello(token, modelloId, fascicoloId, mese) {
  const res = await axios.post(
    `${API_URL}/api/fatturazione/modelli/${modelloId}/preview`,
    {},
    {
      headers: authHeaders(token),
      params: { fascicolo_id: fascicoloId, mese },
    }
  );
  return res.data;
}

// Sincronizza modelli da Fatture in Cloud
export async function syncFicModelli(token, strutturaId) {
  const params = strutturaId ? { strutturaId } : {};
  const res = await axios.post(`${API_URL}/api/fatturazione/modelli/sync-fic`, {}, {
    headers: authHeaders(token),
    params,
  });
  return res.data;
}

// Lista variabili supportate
export async function getVariabiliModelli(token) {
  const res = await axios.get(`${API_URL}/api/fatturazione/modelli/variabili`, {
    headers: authHeaders(token),
  });
  return res.data;
}
